'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dist = {};

exports.__exports = dist;
